import * as Scrivito from "scrivito"

import { ProductCategoryPage } from "pages/product-category-page/ProductCategoryPage"

import { ProductCategoryObjClass } from "./ProductCategoryObjClass"

Scrivito.provideComponent(ProductCategoryObjClass, ProductCategoryPage)
